import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  moreToolsSectionsMenu: {
    '& .rc-tooltip-inner': {
      padding: 0,
    },
  },
}));

export default useStyles;
